/** SSI staff roles that share list/detail/create privileges (DEF-29/31 consolidation). */
export const SSI_STAFF_ROLES = ['Admin', 'SSIAdministrator', 'SSIEmployee'] as const;

/** Returns true when the role is SSI staff (Admin, SSIAdministrator, or SSIEmployee). */
export function isSsiStaffRole(role: string | undefined): boolean {
  return role != null && (SSI_STAFF_ROLES as readonly string[]).includes(role);
}
